import React from "react";

const SettingModalRedButton = ({ label, toggle, btnClass }) => {
  return (
    <div className="modalSetRedBtn" onClick={toggle}>
      <label
        className={
          btnClass === undefined
            ? "per_btn_label2"
            : btnClass && btnClass === "step0"
            ? "per_btn_label2 greenText"
            : btnClass
            ? "per_btn_label2 blueText "
            : "per_btn_label2 greenText"
        }
      >
        {label}
      </label>
      <button
        className={
          btnClass === undefined
            ? "permit_red_btn"
            : btnClass && btnClass === "step0"
            ? "permit_red_btn greenbtn"
            : btnClass
            ? "permit_red_btn blueBtn"
            : "permit_red_btn greenbtn"
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
        >
          <path
            d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 0L9.88 8L1.88 16Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  );
};

export default SettingModalRedButton;
